import {Col, Modal, Row} from "antd"
import {BaseButton} from "components"
import styles from "./PaymentsTable.module.css"
import React, {useCallback} from "react"
import BankAccountSelect from "components/BankAccountSelect"
import {BankAccount} from "types/student-account/bank-account"
import {useTranslation} from "react-i18next"
import {BaseDatePicker} from "components/DateTimePicker"
import moment, {Moment} from "moment"
import {StudentPayment} from "types/student-account/student-payment"
import {FormLabel} from "components/Form"

type PostModalProps = {
    visible: boolean
    onClose: () => void
    onSubmit: (payload: Partial<StudentPayment>) => void
}
const PostModal = ({visible, onClose, onSubmit}: PostModalProps) => {
    const {t} = useTranslation(["studentAccount", "common"])
    const [selectedBankAccount, setSelectedBankAccount] = React.useState<BankAccount | undefined>()
    const [depositDate, setDepositDate] = React.useState<Moment | null>(moment())

    const handleSubmit = useCallback(() => {
        onSubmit({bankAccountId: selectedBankAccount?.accountId, postedDate: depositDate?.toISOString()})
    }, [onSubmit, selectedBankAccount, depositDate])

    return (
        <Modal keyboard={false} closable={false} centered open={visible} onCancel={onClose} footer={null}>
            <h2 className={styles.modalTitle}>Select Bank Account</h2>

            <FormLabel label="Bank Account" />
            <BankAccountSelect isClearable value={selectedBankAccount} onChange={setSelectedBankAccount} />

            <FormLabel label="Deposit Date" className="mt-24" />
            <BaseDatePicker
                allowClear={false}
                value={depositDate ? moment(depositDate) : null}
                onChange={setDepositDate}
            />

            <Row gutter={16} justify="space-between" className="mt-24">
                <Col>
                    <BaseButton title={t("common:action.cancel")} variant="secondary" onClick={onClose} />
                </Col>
                <Col>
                    <BaseButton title={t("common:action.done")} onClick={handleSubmit} />
                </Col>
            </Row>
        </Modal>
    )
}

export default PostModal
